import lozad from 'lozad'

const thumbnail = lozad('.thumb--js', {
	load: function(el) {
		el.src = el.getAttribute('data-src');
		el.srcset = el.getAttribute('data-srcset');
		el.sizes = el.getAttribute('data-sizes');
	},
	loaded: function(el) {
		el.classList.add('loaded', 'fade');
	},
	rootMargin: '10px 0px',
	threshold: 0.1
});

const home = lozad('.home .bckg--js', {
	load: function(el) {
		if (el.getAttribute('data-background-image')) {
			el.style.backgroundImage = 'linear-gradient(to bottom, rgba(255, 255, 255, 0.9) 0%, rgba(255, 255, 255, 0.6) 16%, rgba(255, 255, 255, 0.1) 25%, rgba(255, 255, 255, 0) 100%), url(\'' + el.getAttribute('data-background-image').split(',').join('\'),url(\'') + '\')';
		}
	},
	loaded: function(el) {
		el.classList.add('loaded', 'fade');
	},
	rootMargin: '10px 0px',
	threshold: 0.1
});

const bckg = lozad('.bckg--js', {
	load: function(el) {
		if (el.getAttribute('data-background-image')) {
			el.style.backgroundImage = 'linear-gradient(to bottom, rgba(255, 255, 255, 0.9) 0%, rgba(255, 255, 255, 0.6) 32%, rgba(255, 255, 255, 0.1) 50%, rgba(255, 255, 255, 0) 100%), url(\'' + el.getAttribute('data-background-image').split(',').join('\'),url(\'') + '\')';
		}
	},
	loaded: function(el) {
		el.classList.add('loaded', 'fade');
	},
	rootMargin: '10px 0px',
	threshold: 0.1
});

const parallax = lozad('.parallax--js', {
	loaded: function(el) {
		el.classList.add('loaded', 'fade');
	},
	rootMargin: '10px 0px',
	threshold: 0.1
});

thumbnail.observe();
home.observe();
bckg.observe();
parallax.observe();
